import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  rawProducts: [], // All fetched products
  filteredProducts: [], // Products after applying filters
  activeFilters: {}, // Active filters
};

const productSlice = createSlice({
  name: "products",
  initialState,
  reducers: {
    setProducts: (state, action) => {
      state.rawProducts = action.payload;
      // state.filteredProducts = action.payload; // Show all products initially
    },

    setFilter: (state, action) => {
      state.activeFilters = action.payload;
      // state.filteredProducts = filterProducts(state.rawProducts, action.payload); // Apply filters
    },

    clearFilters: (state) => {
      state.activeFilters = null;
      // state.filteredProducts = state.rawProducts; // Reset to raw products
    },
  },
});

// Helper function to apply filters to the products
// const filterProducts = (products, filters) => {
//   return products.filter((product) => {
//     return Object.keys(filters).every((key) => {
//       return product[key] === filters[key]; // Modify based on your filter conditions
//     });
//   });
// };

export const { setProducts, setFilter, clearFilters } = productSlice.actions;

export default productSlice.reducer;
